
export const getSurfacePosition = ({ land_type, surface_type, size,imageDetail }: any) => {
const frame =  imageDetail?.frame?.find((data:any)=>data.id ===land_type)
const object =  imageDetail?.object?.find((data:any)=>data.id ===surface_type)

const getCommonImage =(id:any)=>{
  const common =  imageDetail?.common?.find((data:any)=>data.id ===id)  
   return common?.img
}

  const planetConfig: any = {
    8: {
      11: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -4,
        land_z: -1.1,
        surface: object?.img,
        surface_size: [2, 3],
        surface_x: size == "lg" ? -0.4 : -1.2,
        surface_y: size == "lg" ? -0.15 : 1.3,
        surface_z: size == "lg" ? 2.1 : 4,
        family: getCommonImage(imageConfig.family),
        family_size: [0.2, 0.3],
        family_x: size == "lg" ? 0.9 : 1,
        family_y: size == "lg" ? -1.55 : -1.3,
        family_z: size == "lg" ? 1.2 : 1.2,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: getCommonImage(imageConfig.skating),
        boy_size: [0.2, 0.2],
        boy_x: size == "lg" ? -0.7 : -0.7 ,
        boy_y: size == "lg" ? -1.5 : -1.5,
        boy_z: size == "lg" ? 0.5 : 0.5,
        cycle: { right: getCommonImage(imageConfig.cycle1), left: getCommonImage(imageConfig.cycle2) },
        cycle_size: [0.2, 0.2],
        cycle_position: {
          right: size == "lg" ? [0.5, -1.5, 1] : [0.5, -1.3, 1],
          left: size == "lg" ? [0.16, -1.5, 1] : [0.16, -1.3, 1],
        },
      },
      12: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -4,
        land_z: -1.1,
        surface: object?.img,
        surface_size: [1.5, 2],
        surface_x: size == "lg" ? -0.1 : -0.2,
        surface_y: size == "lg" ? -0.2 : 0.3,
        surface_z: size == "lg" ? 2.1 : 2.1,
        family: false,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: getCommonImage(imageConfig.skating),
        boy_size: [0.2, 0.2],
        boy_x: size == "lg" ? -1 : -0.7 ,
        boy_y: size == "lg" ? -1.6 : -1.5,
        boy_z: size == "lg" ? 0.5 : 0.5,
        cycle: { right: getCommonImage(imageConfig.cycle1), left: getCommonImage(imageConfig.cycle2) },
        cycle_size: [0.2, 0.2],
        cycle_position: {
          right: size == "lg" ? [0.5, -1.5, 1] : [0.5, -1.3, 1],
          left: size == "lg" ? [0.16, -1.5, 1] : [0.16, -1.3, 1],
        },
      },
      13: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -4,
        land_z: -1.1,
        surface: object?.img,
        surface_size: size == "lg" ? [1.2, 1.2] : [2, 2],
        surface_x: size == "lg" ? -0.3 : -0.2,
        surface_y: size == "lg" ? -0.74 : -0.1,
        surface_z: size == "lg" ? 2.1 : 2.1,
        family: getCommonImage(imageConfig.family),
        family_size: [0.2, 0.3],
        family_x: size == "lg" ? 0.9 : 1,
        family_y: size == "lg" ? -1.55 : -1.3,
        family_z: size == "lg" ? 1.2 : 1.2,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: false,
        cycle: false,
      },
    },
    9: {
      11: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -3.6,
        land_z: -1.1,
        surface: object?.img,
        surface_size: [2, 3],
        surface_x: size == "lg" ? -0.4 : -1.2,
        surface_y: size == "lg" ? -0.15 : 1.3,
        surface_z: size == "lg" ? 2.1 : 4,
        family: getCommonImage(imageConfig.family),
        family_size: [0.2, 0.3],
        family_x: size == "lg" ? 0.6 : 1,
        family_y: size == "lg" ? -1.44 : -1,
        family_z: size == "lg" ? 1.2 : 1.2,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: getCommonImage(imageConfig.skating),
        boy_size: [0.2, 0.2],
        boy_x: size == "lg" ? -0.7 : -0.7 ,
        boy_y: size == "lg" ? -1.6 : -1.5,
        boy_z: size == "lg" ? 0.5 : 0.5,
        cycle: { right: getCommonImage(imageConfig.cycle1), left: getCommonImage(imageConfig.cycle2) },
        cycle_size: [0.2, 0.2],
        cycle_position: {
          right: size == "lg" ? [0.5, -1.5, 0.8] : [0.5, -1.3, 0.8],
          left: size == "lg" ? [0.16, -1.5, 0.8] : [0.16, -1.3, 0.8],
        },
      },
      12: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -3.6,
        land_z: -1.1,
        surface: object?.img,
        surface_size: [1.5, 2],
        surface_x: size == "lg" ? -0.1 : -0.2,
        surface_y: size == "lg" ? -0.1 : 0.3,
        surface_z: size == "lg" ? 2.1 : 2.1,
        family: false,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: getCommonImage(imageConfig.skating),
        boy_size: [0.2, 0.2],
        boy_x: size == "lg" ? -1 : -0.7 ,
        boy_y: size == "lg" ? -1.6 : -1.5,
        boy_z: size == "lg" ? 0.5 : 0.5,
        cycle: { right: getCommonImage(imageConfig.cycle1), left: getCommonImage(imageConfig.cycle2) },
        cycle_size: [0.2, 0.2],
        cycle_position: {
          right: size == "lg" ? [0.5, -1.5, 0.8] : [0.5, -1.3, 0.8],
          left: size == "lg" ? [0.16, -1.5, 0.8] : [0.16, -1.3, 0.8],
        },
      },
      13: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -3.6,
        land_z: -1.1,
        surface: object?.img,
        surface_size: size == "lg" ? [1.2, 1.2] : [2, 2],
        surface_x: size == "lg" ? -0.3 : -0.2,
        surface_y: size == "lg" ? -0.74 : -0.1,
        surface_z: size == "lg" ? 2.1 : 2.1,
        family: getCommonImage(imageConfig.family),
        family_size: [0.2, 0.3],
        family_x: size == "lg" ? 0.9 : 1.3,
        family_y: size == "lg" ? -1.4 : -1,
        family_z: size == "lg" ? 1.2 : 1.2,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: false,
        cycle: false,
      },
    },
    10: {
      11: {
        public: false,
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -3.6,
        land_z: -1.1,
        surface: object?.img,
        surface_size: [2, 3],
        surface_x: size == "lg" ? -0.4 : -1.2,
        surface_y: size == "lg" ? -0.28 : 1.3,
        surface_z: size == "lg" ? 2.1 : 4,
        family: getCommonImage(imageConfig.family),
        family_size: [0.2, 0.3],
        family_x: size == "lg" ? 0.9 : 1,
        family_y: size == "lg" ? -1.55 : -1.3,
        family_z: size == "lg" ? 1.2 : 1.2,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: getCommonImage(imageConfig.skating),
        boy_size: [0.2, 0.2],
        boy_x: size == "lg" ? -0.7 : -0.7 ,
        boy_y: size == "lg" ? -1.8 : -1.5,
        boy_z: size == "lg" ? 0.5 : 0.5,
        cycle: { right: getCommonImage(imageConfig.cycle1), left: getCommonImage(imageConfig.cycle2) },
        cycle_size: [0.2, 0.2],
        cycle_position: {
          right: size == "lg" ? [0.5, -1.6, 1] : [0.5, -1.3, 1],
          left: size == "lg" ? [0.16, -1.6, 1] : [0.16, -1.3, 1],
        },
      },
      12: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -3.6,
        land_z: -1.1,
        surface: object?.img,
        surface_size: [1.5, 2],
        surface_x: size == "lg" ? -0.1 : -0.2,
        surface_y: size == "lg" ? -0.25 : 0.3,
        surface_z: size == "lg" ? 2.1 : 2.1,
        family: false,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: getCommonImage(imageConfig.skating),
        boy_size: [0.2, 0.2],
        boy_x: size == "lg" ? -1 : -0.7 ,
        boy_y: size == "lg" ? -1.8 : -1.5,
        boy_z: size == "lg" ? 0.5 : 0.5,
        cycle: { right: getCommonImage(imageConfig.cycle1), left: getCommonImage(imageConfig.cycle2) },
        cycle_size: [0.2, 0.2],
        cycle_position: {
          right: size == "lg" ? [0.5, -1.55, 1] : [0.5, -1.3, 1],
          left: size == "lg" ? [0.16, -1.55, 1] : [0.16, -1.3, 1],
        },
      },
      13: {
        land: frame?.img,
        land_size: [8, 4],
        land_x: -0.4,
        land_y: -3.6,
        land_z: -1.1,
        surface: object?.img,
        surface_size: size == "lg" ? [1.2, 1.2] : [2, 2],
        surface_x: size == "lg" ? -0.3 : -0.2,
        surface_y: size == "lg" ? -0.8 : -0.2,
        surface_z: size == "lg" ? 2.1 : 2.1,
        family: getCommonImage(imageConfig.family),
        family_size: [0.2, 0.3],
        family_x: size == "lg" ? 0.9 : 1,
        family_y: size == "lg" ? -1.55 : -1.3,
        family_z: size == "lg" ? 1.2 : 1.2,
        bench: getCommonImage(imageConfig.bench),
        bench_size: [0.3, 0.3],
        bench_x: size == "lg" ? -2 : -2.2,
        bench_y: size == "lg" ? -1.8 : -1.5,
        bench_z: size == "lg" ? 0.5 : 0.5,
        boy: false,
        cycle: false,
      },
    },
  };

  return planetConfig[land_type][surface_type];
};



export const imageConfig ={
  'hand':18,
  'mobile_man':19,
  'cycle1':20,
  'cycle2':21,
  'cloud2':22,
  'cloud1':23,
  'fire_stone':24,
  'blue_planet':25,
  'skating':26,
  'family':27,
  'bench':28,
  'ring_planet':29,
  'fire_planet':30,
  'ufo':31,

}